<template>
  <!--編輯-->
  <v-dialog v-model="isVisible"
            no-click-animation
            max-width="80%">
    <v-card>
      <v-card-title>
        <h1>{{ item.displayId }} 設定撥款資料 </h1>
      </v-card-title>
      <v-card-text>
        <v-layout>
          <v-flex md6 xs6>
            <h2>核准金額: {{item.approvedPrice}}</h2>
          </v-flex >
        </v-layout>
        <v-layout>
          <v-flex md6 xs6>
            <h3>代償件/借新還舊件 前貸金額</h3>
            <v-text-field v-model="item.originAmount" label="前貸金額" type="number" outline></v-text-field>
          </v-flex >
          <v-flex md6 xs6>
            <v-checkbox
              v-model="item.isPaid"
              label="是否已撥款"
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout mt-2></v-layout>
        <h3> 代墊款明細 </h3>
        <v-layout>
          <v-flex md6 xs6>
            <v-text-field v-model="item.amount" label="代墊金額" type="number" outline></v-text-field>
          </v-flex >
          <v-flex md6 xs6>
            <v-text-field v-model="item.fee" label="代墊手續費" type="number" outline></v-text-field>
          </v-flex>
        </v-layout>
        <hr/>
        <v-layout mt-2></v-layout>
        <h3> 代扣費用明細 </h3>
        <v-layout>
          <v-flex md6 xs6>
            <v-text-field v-model="item.pad" label="代墊總額" type="number" outline></v-text-field>
          </v-flex >
          <v-flex md6 xs6>
            <v-text-field v-model="item.padFee" label="通路服務費" type="number" outline></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 xs6>
            <v-text-field v-model="item.ticketPrice" label="其他費用" type="number" outline></v-text-field>
          </v-flex >
          <v-flex md6 xs6>
            <v-text-field v-model="item.settingPrice" label="動保設定費" type="number" outline></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 xs6>
            <v-text-field v-model="item.transferFee" label="匯款費用1(30元)" type="number" outline></v-text-field>
          </v-flex >
          <v-flex md6 xs6>
            <v-text-field v-model="item.total" label="代扣費用總額" type="number" outline></v-text-field>
          </v-flex >
        </v-layout>
        <v-layout>
          <v-flex md6 xs6>
            <v-text-field v-model="item.transferFee2" label="匯款費用2" type="number" outline></v-text-field>
          </v-flex >
          <v-flex md6 xs6>
            <v-text-field v-model="item.transferFee3" label="匯款費用3" type="number" outline></v-text-field>
          </v-flex >
        </v-layout>
        <hr/>
        <v-layout mt-2></v-layout>
        <v-layout>
          <v-btn color="primary" dark text  @click="setAmount()">計算總額</v-btn>
        </v-layout>

        <h3> 總計 </h3>
        <v-layout>
          <v-flex md3 xs3>
            <v-text-field v-model="item.realAmount" label="實撥金額" type="number" outline></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>

          <v-flex md6 xs6>
            <h5>一撥時間</h5>
            <date-picker :date.sync="item.payTime1" :dateString="item.payTime1" />
            <!--              <v-text-field v-model="item.payTime1" label="一撥時間" outline></v-text-field>-->
          </v-flex >
          <v-flex md6 xs6>
            <h5>二撥時間</h5>
            <date-picker :date.sync="item.payTime2" :dateString="item.payTime2" />
            <!--              <v-text-field v-model="item.payTime2" label="二撥時間" outline></v-text-field>-->
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <span style="color: red;">{{message}}</span>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" dark text @click="closeEvent">取消</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark text  :loading="saveLoading" @click="saveSetting()">儲存</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePicker from "../components/DatePicker";
import { mapActions } from 'vuex';
import { formatDate } from '@/pages/utils/tool';
export default {
  name: 'AppropriationDialog',
  components: {
    DatePicker
  },
  props: {
    visible: Boolean,
    itemDetail: Object,
  },
  data() {
    return {
      item: {
        displayId: '',
        originAmount: '',
        amount: '',
        fee: '',
        pad: '',
        padFee: '',
        ticketPrice: '',
        settingPrice: '',
        total:'',
        realAmount: '',
        payTime1: '',
        payTime2: '',
        isPaid: false,
        createdDate: new Date(),
        updatedDate: new Date(),
        transferFee: 30,
        transferFee2: '',
        transferFee3: '',
        bankId: '',
        bankSubId: '',
        bankName:'',
        bankSubName: '',
        bankAccountName: '',
        bankAccount:'',
        approvedPrice: 0,
      },
      saveLoading: false,
      isVisible: false,
      message: '',
      info: null,
      mode: 'add',
      payTime1: '',
      payTime2: '',
    }
  },
  watch: {
    visible(value) {
      console.log(`show = ${value}`);
      this.message = '';
      this.isVisible = value;
    },
    isVisible(value) {
      console.log(`isVisible = ${value}`);
      if(!value)
      {
        this.closeEvent();
      }
    },
    async itemDetail(value) {
      console.log(`itemDetail  = ${JSON.stringify(value)}`);
      this.item.displayId = value.displayId;
      this.item.approvedPrice = value.totalPrice;
      this.loadData();
    },
    'item.amount'(value){
      if (value && value!==''){
        this.item.pad = parseInt(value) + parseInt(this.item.fee ? this.item.fee: 0);
      }
    },
    'item.fee'(value){
      if (value && value!==''){
        this.item.pad =  parseInt(this.item.amount ? this.item.amount: 0) + parseInt(value);
      }
    }
  },
  methods: {
    ...mapActions(['loadAppropriationInfo', 'createAppropriationInfo', 'updateAppropriationInfo']),
    setTotal(){
      const n1 = parseInt(this.item.pad ? this.item.pad : 0);
      const n2 = parseInt(this.item.padFee ? this.item.padFee : 0);
      const n3 = parseInt(this.item.ticketPrice ? this.item.ticketPrice : 0);
      const n4 = parseInt(this.item.settingPrice ? this.item.settingPrice : 0);
      const n5 = parseInt(this.item.transferFee ? this.item.transferFee : 0);
      const n6 = parseInt(this.item.transferFee2 ? this.item.transferFee2 : 0);
      const n7 = parseInt(this.item.transferFee3 ? this.item.transferFee3 : 0);
      console.log(`setTotal =  ${n1} | ${n2} | ${n3} | ${n4}  | ${n5} | ${n6} | ${n7}`);
      this.item.total = n2 + n3 + n4 + n5 + n6 + n7;
    },
    setAmount(){
      this.setTotal();

      const n1 = parseInt(this.item.approvedPrice ? this.item.approvedPrice : 0);
      const n2 = parseInt(this.item.originAmount ? this.item.originAmount : 0);
      const n3 = parseInt(this.item.total ? this.item.total: 0);
      const n4 = parseInt(this.item.transferFee ? this.item.transferFee: 0);
      console.log(`setAmount ${n1} | ${n2} | ${n3} | ${n4}`);
      this.item.realAmount = parseInt(this.item.approvedPrice) - n2 - n3 - n4;
    },
    async loadData() {
      const res = await this.loadAppropriationInfo({ displayId: this.item.displayId });
      const result = res.data;
      this.info = result.data;
      if (!this.info){
        this.mode = 'add';
      } else {
        this.mode = 'edit';
        this.item = result.data;
        console.log(`loadAppropriationInfo item = ${JSON.stringify(this.item)}`);
        this.$forceUpdate();
      }

    },
    async saveSetting() {
      this.saveLoading = true;
      let res;
      if (this.mode === 'add'){
        res = await this.createAppropriationInfo(this.item);
      } else {
        res = await this.updateAppropriationInfo(this.item);
      }
      this.saveLoading = false;
      const result = res.data;
      console.log(`save Appropriation result =  ${JSON.stringify(result)}`);

      this.message = result.message;
      setTimeout(() => {
        this.message = '';
      }, 3000);
    },
    closeEvent() {
      this.isVisible = false;
      this.$emit('cancelEvent');
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AppropriationDialog.vue